export class BulkCreateReportDto {
  createdNumber: number;
}





